import { Alert } from '@energy-stacks/broker/feature-alert-management-data';

import { useTranslation } from 'react-i18next';
import { getErrorSeverity } from './getErrorSeverity';
import { Chip } from '@mui/material';

type ErrorSeverityCellProps = {
  severity: Alert['severity'];
};

export const ErrorSeverityCell: React.FC<ErrorSeverityCellProps> = ({
  severity,
}) => {
  const [t] = useTranslation('alertManagement');

  const errorSeverity = getErrorSeverity(severity);
  return (
    <Chip
      label={t(`${errorSeverity?.error}`)}
      variant="outlined"
      sx={{
        backgroundColor: 'transparent',
        color: errorSeverity?.color,
        borderColor: errorSeverity?.border,
        width: 100,
        cursor: 'pointer',
      }}
    />
  );
};
